
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import XProgress from 'vux/src/components/x-progress/index.vue'
import Group from 'vux/src/components/group/index.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import VChart from 'vux/src/components/v-chart/v-chart.vue'
import VPoint from 'vux/src/components/v-chart/v-point.vue'
import VLine from 'vux/src/components/v-chart/v-line.vue'
import VScale from 'vux/src/components/v-chart/v-scale.vue'
import VArea from 'vux/src/components/v-chart/v-area.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XCircle from 'vux/src/components/x-circle/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'

import Board from '@/components/Board.vue'
import Bestline from '@/components/Bestline.vue'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { Promise } from 'q'
import { RENJU } from '@/store/modules/settings'

export default {
name: 'game',
directives: {
TransferDom,
},
components: {
Board,
Bestline,
Flexbox,
FlexboxItem,
XButton,
Scroller,
LoadMore,
XTable,
XTextarea,
Actionsheet,
XProgress,
Group,
GroupTitle,
Popup,
VChart,
VPoint,
VLine,
VScale,
VArea,
XDialog,
XCircle,
},
data: function () {
return {
aiTimeUsed: 0,
showLoading: false,
showBalanceOptions: false,
showFlipOptions: false,
showMoveOptions: false,
showScreenshotOptions: false,
showScreenshot: false,
console: console,
evalData: [
{ index: 0, eval: 0, piece: this.$t('game.black') },
{ index: 0, eval: 0, piece: this.$t('game.white') },
],
thinkingCanceled: false,
gifLoading: false,
screenshotData: null,
previewPv: null,
clipboardAvailable: navigator.clipboard && window.isSecureContext
}
},
computed: {
...mapState(['screenWidth', 'screenHeight', 'isOnIOSBrowser']),
...mapState('settings', [
'boardSize',
'indexOrigin',
'rule',
'nbest',
'aiThinkBlack',
'aiThinkWhite',
'showAnalysis',
'showThreatAnalysis',
]),
...mapState('ai', ['outputs', 'thinking', 'lastThinkTime', 'ready', 'loadingProgress']),
...mapState('position', ['position', 'lastPosition', 'winline', 'swaped']),
...mapGetters('settings', ['turnTime', 'matchTime', 'gameRule']),
...mapGetters('ai', ['bestlineStr', 'bestline']),
...mapGetters('position', ['isEmpty', 'playerToMove', 'moveLeftCount', 'posStr']),
buttonBarWidth() {
const Width = 620
if (this.screenWidth >= 1024)
return Math.min(Width, Width + Math.max(0, this.screenWidth - 1024))
else
return Width
},
chartWidth() {
if (this.screenWidth >= 1024 && this.screenWidth / this.screenHeight >= 4 / 3) {
const MarginSum = 30 + 2 * Math.min(20, Math.max(0, 0.3 * this.screenWidth - 350))
const MaxWidth = 600

return Math.min(
this.screenWidth -
Math.max(this.$store.getters.boardCanvasWidth, this.buttonBarWidth) -
MarginSum,
MaxWidth
)
} else {
return this.screenWidth
}
},
bestline() {
return this.bestlineStr(0)
},
balanceOptions() {
return [this.$t('game.balance1'), this.$t('game.balance2')]
},
flipOptions() {
return [
this.$t('game.flip') + ' |',
this.$t('game.flip') + ' -',
this.$t('game.flip') + ' ╲',
this.$t('game.flip') + ' ╱',
]
},
moveOptions() {
return [
this.$t('game.move') + ' ↑',
this.$t('game.move') + ' ↓',
this.$t('game.move') + ' ←',
this.$t('game.move') + ' →',
]
},
shotOptions() {
return [this.$t('game.shotJpg'), this.$t('game.shotGif')]
},
isAITurn() {

if (this.$store.state.settings.analyzeMode) {
return false
}
return (
(this.playerToMove == 'BLACK' && this.aiThinkBlack) ||
(this.playerToMove == 'WHITE' && this.aiThinkWhite)
)
},
gameEnded() {
return this.winline.length > 0 || this.moveLeftCount == 0
},
threatLevels() {
return ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L']
},
threatAnalysis() {
return this.outputs.threatAnalysis || {
black: { NONE: 0, FORBID: 0, L: 0, K: 0, J: 0, I: 0, H: 0, G: 0, F: 0, E: 0, D: 0, C: 0, B: 0, A: 0 },
white: { NONE: 0, FORBID: 0, L: 0, K: 0, J: 0, I: 0, H: 0, G: 0, F: 0, E: 0, D: 0, C: 0, B: 0, A: 0 }
}
},
blackThreatLevels() {
return this.threatLevels.filter(level => this.threatAnalysis.black[level] > 0)
},
whiteThreatLevels() {
return this.threatLevels.filter(level => this.threatAnalysis.white[level] > 0)
},
},
methods: {
...mapMutations('position', {
newBoard: 'new',
setSwaped: 'setSwaped',
}),
...mapMutations('settings', ['setValue']),
...mapMutations('ai', ['clearUsedTime']),
...mapActions('position', [
'setPosStr',
'makeMove',
'backToBegin',
'backward',
'forward',
'forwardToEnd',
'rotate',
'flip',
'moveTowards',
]),
...mapActions('ai', ['think', 'stop', 'restart', 'initEngine', 'clearAllRealtime']),

getThreatLevelDesc(level) {
const descriptions = {
'A': '五连',
'B': '活四',
'C': '冲四活三',
'D': '冲四+',
'E': '冲四',
'F': '双活三',
'G': '活三+',
'H': '活三',
'I': '冲三活二',
'J': '双活二',
'K': '冲三',
'L': '活二'
}
return descriptions[level] || level
},

checkThinking() {
return new Promise((resolve) => {
if (this.thinking) {
this.$vux.confirm.show_i18n({
title: this.$t('game.interruptThinking.title'),
content: this.$t('game.interruptThinking.msg'),
onCancel: () => { },
onConfirm: () => {
this.thinkingCanceled = true
this.stop()
resolve()
},
})
} else resolve()
})
},

onFlipOption(key) {
switch (key) {
case 0:
this.flip([1, 0])
break
case 1:
this.flip([0, 1])
break
case 2:
this.flip([0, 0])
break
case 3:
this.flip([1, 1])
break
}
},

onMoveOption(key) {
switch (key) {
case 0:
this.moveTowards([0, -1])
break
case 1:
this.moveTowards([0, 1])
break
case 2:
this.moveTowards([-1, 0])
break
case 3:
this.moveTowards([1, 0])
break
}
},

onScreenshotOption(key) {
let _this = this
let delayPrompt = this.$t('game.gifDelay')
let startIndex, delay
switch (key) {
case 0:
this.screenshotData = { url: this.$refs.board.screenshot(), ext: 'jpg' }
this.$refs.screenshot.setAttribute('src', this.screenshotData.url)
this.showScreenshot = true
break
case 1:
_this.$vux.confirm.prompt_i18n('', {
title: this.$t('game.gifStart'),
inputAttrs: { type: 'number', min: 1, max: this.position.length },
onShow() {
_this.$vux.confirm.setInputValue('1')
},
onConfirm(v) {
startIndex = +v
if (isNaN(startIndex)) startIndex = 1
startIndex = Math.max(0, Math.min(startIndex - 1, _this.position.length))
_this.$vux.confirm.prompt_i18n('', {
title: delayPrompt,
inputAttrs: { type: 'number', min: 100 },
onShow() {
_this.$vux.confirm.setInputValue('1000')
},
onConfirm(v) {
delay = +v
if (isNaN(delay)) delay = 1000
delay = Math.max(100, delay)
_this.gifLoading = true
_this.$refs.screenshot.setAttribute('src', '')
_this.showScreenshot = true
_this.$refs.board.exportGIF(startIndex, delay, (blob) => {
_this.gifLoading = false
_this.screenshotData = { url: URL.createObjectURL(blob), ext: 'gif' }
_this.$refs.screenshot.setAttribute('src', _this.screenshotData.url)
})
},
})
},
})
break
}
},
saveScreenshot() {
function downloadBlobURL(blobUrl, name) {

const link = document.createElement('a')


link.href = blobUrl
link.download = name


document.body.appendChild(link)



link.dispatchEvent(
new MouseEvent('click', {
bubbles: true,
cancelable: true,
view: window,
})
)


document.body.removeChild(link)
}

downloadBlobURL(
this.screenshotData.url,
`screenshot-${dateFormat(new Date(), 'YYYYMMDDHHmmss')}.${this.screenshotData.ext}`
)
},

newGame() {
this.checkThinking().then(() => {
this.newBoard(this.boardSize)
this.restart()
this.clearAllRealtime()
})
},

clicked(e) {
let pos = [e.x, e.y]
if (this.thinking) return

if (e.button == 0) {
if ((this.isEmpty(pos) && this.winline.length == 0) || this.isAITurn) {
if (!this.isAITurn) {
if (this.rule == 5 && !this.swaped && this.position.length == 1) {

return this.$vux.confirm.show_i18n({
title: this.$t('game.swap.questionTitle'),
content: this.$t('game.swap.questionMsg'),
onCancel: () => {
this.setSwaped()
},
onConfirm: () => {
this.swapBlackAndWhite()
if (this.isAITurn) this.startThink()
},
})
} else if (this.gameRule == RENJU) {
let isForbidPos = false
for (let forbidPos of this.outputs.forbid) {
if (pos[0] == forbidPos[0] && pos[1] == forbidPos[1]) {
isForbidPos = true
break
}
}
if (isForbidPos) {
return this.$vux.alert.show_i18n({
title: this.$t('game.forbid.title'),
content: this.$t('game.forbid.msg'),
})
}
}


this.$store.commit('ai/clearAllRealtime')
this.makeMove(pos)
}
if (this.isAITurn) this.startThink()
}
} else if (e.button == 2) {
this.backward()
this.clearUsedTime()
this.clearAllRealtime()
}
},

startThink() {
if (this.gameEnded) return

this.think().then((result) => {
if (this.thinkingCanceled) {
this.thinkingCanceled = false
return
}


if (!result) {
return
}


if (result && result.analysisResult) {

console.log('Analysis completed:', result.analysisResult)


if (result.analysisResult.realtime && result.analysisResult.realtime.best) {
this.$store.commit('ai/setRealtimeBest', result.analysisResult.realtime.best)
}


if (result.analysisResult.type === 'winning') {
this.$vux.toast.text(result.analysisResult.message)
}

return
}


let pos = result
if (this.outputs.swap) {
this.swapBlackAndWhite()
this.$vux.alert.show_i18n({
title: this.$t('game.swap.title'),
content: this.$t('game.swap.msg'),
onHide() {
if (this.isAITurn) this.startThink()
},
})
} else {
this.makeMove(pos)

let e = +this.outputs.pv[0].eval
if (!isNaN(e)) {
this.evalData.push({
index: this.position.length,
eval: e,
piece: this.playerToMove == 'BLACK' ? this.$t('game.white') : this.$t('game.black'),
})
}

if (this.isAITurn) this.startThink()
}
})
},

startThinkBalance(mode) {
if (this.gameEnded) return

this.think({ balanceMode: mode }).then((result) => {
if (this.thinkingCanceled) {
this.thinkingCanceled = false
return
}


if (result && result.analysisResult) {

console.log('Balance analysis completed:', result.analysisResult)


if (result.analysisResult.realtime && result.analysisResult.realtime.best) {
this.$store.commit('ai/setRealtimeBest', result.analysisResult.realtime.best)
}


if (result.analysisResult.type === 'winning') {
this.$vux.toast.text(result.analysisResult.message)
}

return
}


let pos = result
this.makeMove(pos)
if (mode == 2) {
const pos2 = this.outputs.pv[0].bestline[1]
this.makeMove(pos2)
}
})
},

swapBlackAndWhite() {
this.setSwaped()
let thinkBlack = this.aiThinkWhite
let thinkWhite = this.aiThinkBlack
this.setValue({ key: 'aiThinkBlack', value: thinkBlack })
this.setValue({ key: 'aiThinkWhite', value: thinkWhite })
},

setPvAsPosition(pv) {
this.checkThinking().then(() => {
let fullPosition = pv.position.concat(pv.pv)
this.newBoard(this.boardSize)
this.clearAllRealtime()
for (let pos of fullPosition) {
if (!this.makeMove(pos)) break
}
})
},

getSpeedText(speed) {
if (speed < 10000) {
return speed.toString();
} else if (speed < 100000000) {
return Math.floor(speed / 1000) + "K";
} else {
return Math.floor(speed / 1000000) + "M";
}
},

getNodesText(nodes) {
if (nodes < 10000) {
return nodes.toString();
} else if (nodes < 10000000) {
return Math.floor(nodes / 1000) + "K";
} else if (nodes < 100000000000) {
return Math.floor(nodes / 1000000) + "M";
} else if (nodes < 100000000000000) {
return Math.floor(nodes / 1000000000) + "G";
} else {
return Math.floor(nodes / 1000000000000) + "T";
}
},

getTimeText(time) {
if (time < 1000000) {
return Math.floor(time / 1000) + "." + (Math.floor(time / 100) % 10) + "s";
} else if (time < 360000000) {
return Math.floor(time / 60000) + "min";
} else {
return Math.floor(time / 3600000) + "h";
}
},

async copyPosStrToClipboard() {
await navigator.clipboard.writeText(this.posStr);
this.$vux.toast.text(this.$t('game.copiedToClipboard'))
},

async pastePosStrFromClipboard() {
const posStr = await navigator.clipboard.readText();
this.setPosStr(posStr)
},
},
watch: {
bestline: function () {
if (this.$refs.bestlineArea) this.$refs.bestlineArea.updateAutosize()
},
posStr: function (newPos) {
this.$refs.curposArea.updateAutosize()
let oldIndex = this.evalData[this.evalData.length - 1].index
let newIndex = Math.max(this.position.length, 1)
if (newIndex < oldIndex) {
for (let i = this.evalData.length - 1; i > 0; i--) {
if (this.evalData[i].index > newIndex) this.evalData.pop()
}
}
if (newPos.length > 0) this.$router.push({ name: 'game', params: { pos: newPos } })
else this.$router.push({ name: 'game' })
},
boardSize: function (newSize) {
if (this.thinking) this.stop()
this.newBoard(newSize)
this.restart()
this.clearAllRealtime()
},
loadingProgress: function (progress) {
if (progress == 1) this.showLoading = false
},
},
mounted() {
this.newBoard(this.boardSize)
if (this.$route.params.pos) this.setPosStr(this.$route.params.pos)

window.addEventListener('keydown', (event) => {
const target = event.target

if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable)
return
if (event.repeat)
return

switch (event.key) {
case 'ArrowLeft':
this.checkThinking().then(() => {
this.backward()
this.clearAllRealtime()
})
break
case 'ArrowRight':
this.checkThinking().then(() => {
this.forward()
this.clearAllRealtime()
})
break
case 'Home':
this.checkThinking().then(() => {
this.backToBegin()
this.clearAllRealtime()
})
break
case 'End':
this.checkThinking().then(() => {
this.forwardToEnd()
this.clearAllRealtime()
})
break
case ' ':
if (this.thinking) this.stop()
else if (this.ready && !this.gameEnded) this.startThink()
break
case 'b':
this.checkThinking().then(() => this.startThinkBalance(1))
break
case 'B':
this.checkThinking().then(() => this.startThinkBalance(2))
break
}
})
setInterval(() => {
this.aiTimeUsed = this.thinking ? Date.now() - this.lastThinkTime : 0
}, 100)

this.initEngine().catch((err) => {
this.$vux.alert.show_i18n({
title: this.$t('game.engineLoadingError'),
content: err.toString(),
})
})
},
}
